import { render, staticRenderFns } from "./SampleReceiveLabelIndex.vue?vue&type=template&id=08fcaa38"
import script from "./SampleReceiveLabelIndex.vue?vue&type=script&lang=js"
export * from "./SampleReceiveLabelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports